export default __webpack_public_path__ + "static/lines-and-data-79541e38ec023bae3f0e0875ced60889.webp";